import { render, staticRenderFns } from "./CaseViewerHeaderDescription.vue?vue&type=template&id=3305156c&scoped=true&"
import script from "./CaseViewerHeaderDescription.vue?vue&type=script&lang=js&"
export * from "./CaseViewerHeaderDescription.vue?vue&type=script&lang=js&"
import style0 from "./CaseViewerHeaderDescription.vue?vue&type=style&index=0&id=3305156c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3305156c",
  null
  
)

export default component.exports